import React from 'react'
import { Container, Navbar } from 'react-bootstrap'
import { useLocation, Link } from 'react-router-dom'
import Apikey from './apikey'
import Machine from './machine'
import Heure from './heure'
import * as Constants from '../src/constants'

const TopNavbar = ({
  oldData,
  apikey,
  manualApikey,
  machineName,
  sentinel
}) => {
  const location = useLocation()

  return (
    <Navbar fixed='top' bg='dark' variant='dark' expand='sm'>
      <Container fluid>
        <Navbar.Brand className='d-flex align-items-center'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='48'
            height='48'
            className='me-3'
            viewBox='0 0 16 16'
            fill={oldData ? '#dc3545' : '#28a745'}
          >
            {oldData ? (
              // Prise déconnectée (rouge)
              <path d='M6 0a.5.5 0 0 1 .5.5V3h3V.5a.5.5 0 0 1 1 0V3h1a.5.5 0 0 1 .5.5v3A3.5 3.5 0 0 1 8.5 10c-.002.434-.01.845-.04 1.22-.041.514-.126 1.003-.317 1.424a2.083 2.083 0 0 1-.97 1.028C6.725 13.9 6.169 14 5.5 14c-.998 0-1.61.33-1.974.718A1.922 1.922 0 0 0 3 16H2c0-.616.232-1.367.797-1.968C3.374 13.42 4.261 13 5.5 13c.581 0 .962-.088 1.218-.219.241-.123.4-.3.514-.55.121-.266.193-.621.23-1.09.027-.34.035-.718.037-1.141A3.5 3.5 0 0 1 4 6.5v-3a.5.5 0 0 1 .5-.5h1V.5A.5.5 0 0 1 6 0zM5 4v2.5A2.5 2.5 0 0 0 7.5 9h1A2.5 2.5 0 0 0 11 6.5V4H5z'/>
            ) : (
              // Prise connectée (vert)
              <path d='M6 0a.5.5 0 0 1 .5.5V3h3V.5a.5.5 0 0 1 1 0V3h1a.5.5 0 0 1 .5.5v3A3.5 3.5 0 0 1 8.5 10c-.002.434-.01.845-.04 1.22-.041.514-.126 1.003-.317 1.424a2.083 2.083 0 0 1-.97 1.028C6.725 13.9 6.169 14 5.5 14c-.998 0-1.61.33-1.974.718A1.922 1.922 0 0 0 3 16H2c0-.616.232-1.367.797-1.968C3.374 13.42 4.261 13 5.5 13c.581 0 .962-.088 1.218-.219.241-.123.4-.3.514-.55.121-.266.193-.621.23-1.09.027-.34.035-.718.037-1.141A3.5 3.5 0 0 1 4 6.5v-3a.5.5 0 0 1 .5-.5h1V.5A.5.5 0 0 1 6 0zm4 4H5v2.5A2.5 2.5 0 0 0 7.5 9h1A2.5 2.5 0 0 0 11 6.5V4z'/>
            )}
          </svg>
          <div className='d-flex flex-column'>
            <Navbar.Text className='lh-1' style={{ fontSize: '0.8rem' }}>{Constants.appTitle}</Navbar.Text>
            <Navbar.Text className='text-warning lh-1'>
              <Machine name={machineName} />
            </Navbar.Text>
          </div>
        </Navbar.Brand>

        {location.pathname != '/' && (
          <Navbar.Collapse className='justify-content-between'>
            <Link to='/' className='btn btn-primary btn-lg'>
              Retour page principale
            </Link>
          </Navbar.Collapse>
        )}

        <Navbar.Collapse className='justify-content-end'>
          <Navbar.Text className='h2 text-white mb-0 pe-4'>
            <Heure />
          </Navbar.Text>
          <Navbar.Text>
            <Apikey
              apikey={apikey}
              manualApikey={manualApikey}
              sentinel={sentinel}
            />
          </Navbar.Text>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default TopNavbar
